var React = require('react');

function IconSpotify (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"spotify"),React.createElement("path",{"d":"M50,25A25,25,0,1,0,75,50,25,25,0,0,0,50,25ZM61.47,61.06a1.56,1.56,0,0,1-2.15.52c-5.87-3.59-13.26-4.4-22-2.41a1.56,1.56,0,0,1-.69-3C46.19,54,54.36,54.89,61,58.92A1.57,1.57,0,0,1,61.47,61.06Zm3-6.81a1.94,1.94,0,0,1-2.68.64c-6.72-4.13-17-5.32-24.91-2.91a1.95,1.95,0,0,1-1.13-3.73c9.08-2.75,20.37-1.42,28.08,3.32A1.94,1.94,0,0,1,64.52,54.25Zm.27-7.09c-8.06-4.78-21.35-5.22-29.05-2.89a2.33,2.33,0,1,1-1.35-4.47c8.83-2.68,23.51-2.17,32.79,3.34a2.34,2.34,0,0,1-2.39,4Z","key":1})]);
}

IconSpotify.displayName = "IconSpotify";

IconSpotify.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = IconSpotify;

IconSpotify.default = IconSpotify;
